/* eslint-disable no-param-reassign */
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { axiosInstance } from "@app/axios/axiosIns";

export const addCareerCategory = createAsyncThunk(
  "careerCategory/add",
  async (data: any, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(`/admin/career-category`, data);
      return response?.data;
    } catch (error: any) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const getAllCareerCategories = createAsyncThunk(
  "careerCategory/all",
  async (params: any, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get("/career-category", { params });
      return response?.data;
    } catch (error: any) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const getCareerCategoryById = createAsyncThunk(
  "careerCategory/getById",
  async (id: any, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(`/career-category/${id}`);
      return response?.data;
    } catch (error: any) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const updateCareerCategory = createAsyncThunk(
  "careerCategory/update",
  async ({ id, data }: { id: any; data: any }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.patch(
        `/admin/career-category/${id}`,
        data
      );
      return response?.data;
    } catch (error: any) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const deleteCareerCategory = createAsyncThunk(
  "careerCategory/delete",
  async (id: string, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.delete(
        `/admin/career-category/${id}`
      );
      return response?.data;
    } catch (error: any) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

interface CareerCategoryState {
  isLoading: boolean;
  formLoading: boolean;
  careerCategory: any;
  allCareerCategories: any[];
  error: any;
}

const initialState: CareerCategoryState = {
  isLoading: false,
  formLoading: false,
  careerCategory: null,
  allCareerCategories: [],
  error: null,
};

export const careerCategorySlice: any = createSlice({
  name: "careerCategory",
  initialState,
  reducers: { resetState: () => initialState },
  extraReducers: (builder) => {
    builder
      .addCase(addCareerCategory.pending, (state) => {
        state.formLoading = true;
      })
      .addCase(addCareerCategory.fulfilled, (state, action) => {
        state.formLoading = false;
        state.careerCategory = action.payload;
      })
      .addCase(addCareerCategory.rejected, (state, action) => {
        state.formLoading = false;
        state.error = action.error.message;
      })
      .addCase(getAllCareerCategories.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getAllCareerCategories.fulfilled, (state, action) => {
        state.isLoading = false;
        state.allCareerCategories = action.payload;
      })
      .addCase(getAllCareerCategories.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message;
      })
      .addCase(getCareerCategoryById.pending, (state) => {
        state.formLoading = true;
      })
      .addCase(getCareerCategoryById.fulfilled, (state, action) => {
        state.formLoading = false;
        state.careerCategory = action.payload;
      })
      .addCase(getCareerCategoryById.rejected, (state, action) => {
        state.formLoading = false;
        state.error = action.error.message;
      })
      .addCase(updateCareerCategory.pending, (state) => {
        state.formLoading = true;
      })
      .addCase(updateCareerCategory.fulfilled, (state, action) => {
        state.formLoading = false;
        state.careerCategory = action.payload;
      })
      .addCase(updateCareerCategory.rejected, (state, action) => {
        state.formLoading = false;
        state.error = action.error.message;
      })
      .addCase(deleteCareerCategory.pending, (state) => {
        state.formLoading = true;
      })
      .addCase(deleteCareerCategory.fulfilled, (state, action) => {
        state.formLoading = false;
        state.careerCategory = action.payload;
      })
      .addCase(deleteCareerCategory.rejected, (state, action) => {
        state.formLoading = false;
        state.error = action.error.message;
      });
  },
});

export const { resetState } = careerCategorySlice.actions;
export default careerCategorySlice.reducer;

